<form class="app-form">
  <div class="setup-content" id="step-4">
    <h4>{{'MESSAGES.INFOS.LETS_GET_YOU_VERIFIED' | translate }}</h4>
    <p class="theme-font-color mb-0">
      {{ displayMessage() }} {{ channelType() }}
      <strong>{{ channelValue() }}</strong>
    </p>
    <div class="form-group my-4">
      <div class="pin">
        <code-input
          #otpNumber
          class="code-input"
          [disabled]="verifyGUID() === null"
          id="passcode"
          [isCodeHidden]="isCodeHidden()"
          [codeLength]="4"
          (codeCompleted)="verifyOtp($event)"
        >
        </code-input>
      </div>
    </div>

    <div class="flex flex-row items-start justify-between mb-0">
      <p class="theme-font-color mb-0">
        {{ 'MESSAGES.PROMPTS.DIDNT_RECEIVE_CODE' | translate }}
        <button
          type="button"
          class="cursor-pointer btn-bare text-primary [font:inherit] [letter-spacing:inherit]"
          (click)="getOtp()"
        >
          {{ 'LABELS.RESEND_TIMER' | translate: { timeLeft: timeLeft() } }}
        </button>
      </p>
      <button class="btn btn-outline-dark" type="button" (click)="goBack.emit()">
        {{ 'LABELS.BACK' | translate }}
      </button>
    </div>
  </div>
</form>
